// Copyright (c) 2017 Deere & Company

import ReportHiddenColumns from './report-columns';
import {connect} from 'react-redux';
import {sharedActionCreators} from '../../action-creators';

const getStateToBindToContainerProps = state => ({
    columnApi: state.columnApi,
    hiddenColumns: state.reportVariant.selectedLayout ?
        state.reportVariant.selectedLayout.columnState.filter(column => column.hide) :
        [],
    selectedLayout: state.reportVariant.selectedLayout
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    actions: {
        onClick: columnId => {

            const columnIndexToBeAdded = stateProps.selectedLayout.columnState.findIndex(column => column.colId === columnId);

            dispatchProps.showReportColumn(columnIndexToBeAdded, columnId);

        },
        onClose: () => {

            dispatchProps.updateReportColumnsVisibility(false);

        }
    },
    ...ownProps
});

export default connect(getStateToBindToContainerProps, sharedActionCreators, mapBoundActionCreatorsToActionsProp)(ReportHiddenColumns);



// WEBPACK FOOTER //
// ./src/reports/shared/components/report-columns/index.js